.attributionSummary {
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 4px;
}
